import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainScreen from '../components/MainScreen';
import ProjectScreen from '../components/ProjectScreen';
import VeevaProjectsPage from '../components/VeevaProjectsPage';

const RouterApp = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<MainScreen />} />
                <Route path='/proyecto/:id' element={<ProjectScreen />} />
                <Route path='/veeva-projects' element={<VeevaProjectsPage />} />
            </Routes>
        </BrowserRouter>
    );
};

export default RouterApp;
